// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
import { NgModule } from '@angular/core';

// DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';

const SOCO_MODULE_DIRECTIVES = [
];

@NgModule({
    exports: SOCO_MODULE_DIRECTIVES,
    declarations: SOCO_MODULE_DIRECTIVES,
    providers: [
        //    DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
        SocoConfigurationService
    ]
})
export class SocoConfigurationModule { }
